const mixinGeral = {
  data() {
    return {
      themeData: null,
    };
  },
  computed: {
    isDark() {
      return (this.$vuetify.theme.dark)
      ? true
      : false;
    },
    themeName() {
      return this.themeData?.name || '';
    },
    logotypeLight() {
      return this.themeData?.data?.light?.assets?.logo || '';
    },
    logotypeDark() {
      return this.themeData?.data?.dark?.assets?.logo || '';
    },
    symbolDark() {
      return this.themeData?.data?.dark?.assets?.symbol || '';
    },
    symbolLight() {
      return this.themeData?.data?.light?.assets?.symbol || '';
    },
    loginBackgroundLight() {
      return this.themeData?.data?.light?.assets?.loginBackground || '';
    },
    loginBackgroundDark() {
      return this.themeData?.data?.dark?.assets?.loginBackground || '';
    }
  },
  created() {
    this.themeData = this.$appTheme || null;
  }
};

export default mixinGeral;